import dayjs from "dayjs"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { useAppDispatch, useAppSelector } from "@/App"
import { Main } from "@/components/AppLayout"
import { Status } from "@/components/Status"
import { PaymentContextMenu, PaymentContextMenuAction, PaymentItemContext } from "@/modules/PaymentContextMenu"
import { getAllPayments, selectPaymentsUpdateTimestamp } from "@/store/payments"
import { selectCurrentTeamId } from "@/store/teams"

import { OrdersWithoutPayments } from "./partials/OrdersWithoutPayments"
import { Payments } from "./partials/Payments"
import { PaymentsSearch } from "./partials/PaymentsSearch"
import { UnsettledPayments } from "./partials/UnsettledPayments"

export const PaymentsView = () => {
  const teamId = useAppSelector(selectCurrentTeamId)
  const updateTimestamp = useAppSelector(selectPaymentsUpdateTimestamp)

  const [paymentsDate, setPaymentsDate] = useState(dayjs().toISOString())

  const [paymentContextMenuAction, setPaymentContextMenuAction] = useState<PaymentContextMenuAction | null>(null)

  const dispatch = useAppDispatch()

  const { t } = useTranslation()

  useEffect(() => {
    if (!teamId) return

    dispatch(
      getAllPayments({
        teamId,
        paymentsParams: {
          ...getPaymentsDataRange(paymentsDate),
        },
      })
    )
  }, [dispatch, paymentsDate, teamId, updateTimestamp])

  if (!teamId) return <Status type="no_team" title={t("payments")} fullHeight />

  return (
    <Main page pageContrast>
      <h1 className="text-light h400">{t("payments")}</h1>

      <PaymentItemContext.Provider value={{ paymentContextMenuAction, setPaymentContextMenuAction }}>
        <UnsettledPayments />
        <OrdersWithoutPayments />
        <PaymentsSearch paymentsDate={paymentsDate} />
        <Payments paymentsDate={paymentsDate} setPaymentsDate={setPaymentsDate} />

        <PaymentContextMenu />
      </PaymentItemContext.Provider>
    </Main>
  )
}

export function getPaymentsDataRange(date: string) {
  return {
    start_date: dayjs(date).startOf("month").format("YYYY-MM-DD"),
    end_date: dayjs(date).endOf("month").format("YYYY-MM-DD"),
  }
}
